import { RootState } from "../../../index";

export const selectPendingTokenValidation = (state: RootState) =>
  state.tokenValidation.pending;
export const selectErrorTokenValidation = (state: RootState) =>
  state.tokenValidation.error;
export const selectSessionChecked = (state: RootState) =>
  state.tokenValidation.sessionChecked;
export const selectValidationData = (state: RootState) =>
  state.tokenValidation.data;
